import { c as _c } from "react/compiler-runtime";
import { produce } from 'immer';
import { useState } from 'react';
import type { VocabularySourceData, VocabularySourceState } from '@/app/[locale]/(vocabulary)/_lib/vocab';
const preserveInertialPhase = (list: VocabularySourceState[]) => (oldRows: VocabularySourceState[]) => {
  const listItemMap = new Map<string, VocabularySourceState>();
  for (const listItem of list) {
    for (const {
      pathe
    } of listItem.wordFamily) {
      listItemMap.set(pathe, listItem);
    }
  }
  for (const oldRow of oldRows) {
    for (const {
      pathe
    } of oldRow.wordFamily) {
      const listItem = listItemMap.get(pathe);
      if (listItem) {
        if (listItem.inertialPhase !== oldRow.inertialPhase) {
          listItem.inertialPhase = oldRow.inertialPhase;
        }
        break;
      }
    }
  }
  return list;
};
export const useManagedVocabulary = list => {
  const $ = _c(5);
  let t0;
  if ($[0] !== list) {
    t0 = list.map(_temp);
    $[0] = list;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const vocabularyStates = t0;
  const [previousVocabularyStates, setPreviousVocabularyStates] = useState(vocabularyStates);
  const [rows, setRows] = useState(vocabularyStates);
  if (previousVocabularyStates !== vocabularyStates) {
    setPreviousVocabularyStates(vocabularyStates);
    setRows(preserveInertialPhase(vocabularyStates));
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setRows(produce(_temp3));
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const syncPhases = t1;
  let t2;
  if ($[3] !== rows) {
    t2 = [rows, syncPhases];
    $[3] = rows;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2 as const;
};
function _temp(i) {
  return {
    ...i,
    inertialPhase: i.trackedWord.learningPhase
  };
}
function _temp2(row) {
  if (row.inertialPhase !== row.trackedWord.learningPhase) {
    row.inertialPhase = row.trackedWord.learningPhase;
  }
}
function _temp3(draft) {
  draft.forEach(_temp2);
}